import { CognitoUserInterface } from "@aws-amplify/ui-components";
import { ActionTypes } from "./ActionTypes";
import { Action, ActionCreator } from "redux";

export const setUser: ActionCreator<Action> = (
    user: CognitoUserInterface | undefined
) => {
    return {
        type: ActionTypes.SET_USER,
        user: user
    };
};

export const setUserType: ActionCreator<Action> = (
    userType: string
) => {
    return {
        type: ActionTypes.SET_USER_TYPE,
        userType
    };
}